import { GovField } from "@publicMirage/components/govReact/GovField";
import { ErrorText, FormGroup, H3, InsetText, LabelText } from "govuk-react";
import React, { memo } from "react";
import { useForm } from "../hooks/formContext";
import {
    PrePpWlDescriptionOfDevelopmentDevelopmentTypes,
    PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes,
} from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";

export const PrePpWlAlterationsOrExtensionsToExistingHouseType = memo(() => {
    const { toFieldProps, formState, getFieldProp } = useForm();
    const { typeOfDevelopment } = formState;
    if (typeOfDevelopment.value !== PrePpWlDescriptionOfDevelopmentDevelopmentTypes.ALTERATIONS_EXTENSIONS) {
        return null;
    }
    const errorMsg = getFieldProp("developmentScale", "errorMsg");
    return (
        <>
            <H3>Type A: Alterations or extensions to an existing house or building</H3>
            <FormGroup error={!!errorMsg}>
                <LabelText className="required">Scale of development</LabelText>
                <ErrorText>{errorMsg}</ErrorText>
                <GovField
                    {...toFieldProps("developmentScale", "RADIO", PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes.EXTENSION)}
                    label="Extension (e.g. conservatory)"
                />
                <GovField
                    {...toFieldProps("developmentScale", "RADIO", PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes.OUTBUILDING)}
                    label="Outbuilding (e.g. garage, shed)"
                />
                <GovField {...toFieldProps("developmentScale", "RADIO", PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes.OTHER)} label="Other (e.g. solar panels)" />
            </FormGroup>
            <AlterationDimensionsFields />
            <Other />
        </>
    );
});

const AlterationDimensionsFields = memo(() => {
    const { toFieldProps, formState } = useForm();
    const showAlterationDimensionsTypes = [
        PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes.EXTENSION,
        PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes.OUTBUILDING,
    ];
    const showAlterationDimensions = showAlterationDimensionsTypes.includes(formState.developmentScale.value as any);
    if (!showAlterationDimensions) {
        return null;
    }
    return (
        <>
            <InsetText>For extensions and outbuildings, please include the proposed dimensions in metres.</InsetText>
            <GovField {...toFieldProps("alterationWidth", "TEXT")} />
            <GovField {...toFieldProps("alterationLength", "TEXT")} />
            <GovField {...toFieldProps("alterationHeightToEaves", "TEXT")} />
            <GovField {...toFieldProps("alterationHeight", "TEXT")} />
        </>
    );
});

const Other = memo(() => {
    const { toFieldProps, formState } = useForm();
    const { developmentScale } = formState;
    if (developmentScale.value !== PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes.OTHER) {
        return null;
    }
    return (
        <>
            <GovField {...toFieldProps("otherAlterationOrExtensionSpecified", "TEXTAREA")} />
        </>
    );
});
